export const generateInitials = (name: string): string => {
    const nameParts = name.trim().split(' ');

    if (nameParts.length === 1) {
        return nameParts[0].charAt(0).toUpperCase();
    } else if (nameParts.length > 1) {
        return nameParts[0].charAt(0).toUpperCase() + nameParts[1].charAt(0).toUpperCase();
    }

    return '';
};
